import { useCachedData } from './useCachedData';
import { supabase } from '../utils/supabase';
import { useAuth } from '../context/AuthContext';
import { CACHE_KEYS } from '../constants/cacheKeys';
import { CareerFocusWithMetrics, calculateMetrics } from './useCareerFocus';

export const useAllActiveFocuses = () => {
  const { user } = useAuth();

  const cacheKey = user?.id ? `${CACHE_KEYS.ALL_ACTIVE_FOCUSES}_${user.id}` : null;

  const { data: focuses = [], error, loading, refresh } = useCachedData<CareerFocusWithMetrics[]>(
    async () => {
      if (!user?.id) return [];

      const { data, error } = await supabase
        .from('user_career_focuses')
        .select(`
          *,
          goals:user_focus_goals(*)
        `)
        .eq('user_id', user.id)
        .eq('is_active', true)
        .order('created_at', { ascending: false });

      if (error) {
        console.error('[useAllActiveFocuses] Query error:', error);
        throw error;
      }

      // Calculate metrics for each focus
      return (data || []).map(focus => calculateMetrics(focus));
    },
    {
      cacheKey: cacheKey || 'temp_all_focuses',
      enabled: !!user?.id && !!cacheKey,
      skipCache: !cacheKey,
      onError: (error) => {
        console.error('Failed to load active focuses:', error);
      }
    }
  );

  return { activeFocuses: focuses || [], loading, error, refresh };
};